"use client";

import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";

export function useActiveViewAs() {
  const { isAuthenticated } = useConvexAuth();
  return useQuery(api.viewAs.queries.current, isAuthenticated ? {} : "skip");
}
